<app-component-factory
  [data]="data"
  [componentClass]="componentClass"
  (isVisibleChanged)="isVisibleChanged.emit($event)"
></app-component-factory>
